<template>
  <a v-bind:class="bgImageClassName" :href="loginUrl" role="button" @click="onGoogleSignUp"></a>
</template>

<script>
  import RTGoogleAnalyticsManager from '../../../../common/RTGoogleAnalyticsManager';
  import Utils from '../../../../common/Utils';

  export default {
    props: ['role', 'classcode', 'refcode', 'provider', 'action'],
    computed: {
      timezone() {
        return Utils.getTimeZoneFromBrowser();
      },
      loginUrl() {
        return `/v2/auth/${this.provider}/${this.action}?provider=${this.provider}&register=${this.role}&classcode=${this.classcode}${this.refcode ? '&ref=' + this.refcode : ''}${this.timezone ? '&tz=' + this.timezone : ''}`
      },
      bgImageClassName() {
        return this.getBgImageClassName(this.provider);
      }
    },
    methods: {
      onGoogleSignUp() {
        RTGoogleAnalyticsManager.sendEvent(this.provider, 'create_account', this.role);
        localStorage.setItem('rt-signup-role', this.role);
      },
      getBgImageClassName(provider) {
        const imgState = {
          'google': {"google-sign-in-btn": true, "sign-in-btn": true},
          'microsoft':{"microsoft-sign-in-btn": true, "sign-in-btn": true},
          'clever':{"clever-sign-in-btn": true, "sign-in-btn": true},
        };
        return imgState[provider];
      }
    }
  }

</script>

<style scoped lang="scss">
  @import '../../common/variables';

  .sign-in-btn {
    display: inline-block;
    max-width: 300px;
    width: 300px;
    height: 48px;
    background-size: contain;
    background-repeat: no-repeat;
    cursor: pointer;
  }

  .google-sign-in-btn:hover {
    background-image: url("/assets/app/signup/btn_google_signin_light_focus_web.png");
  }

  .google-sign-in-btn:focus, .google-sign-in-btn:active {
    background-image: url("/assets/app/signup/btn_google_signin_light_pressed_web.png");
    outline: none;
  }

  .google-sign-in-btn {
    background-image: url("/assets/app/signup/btn_google_signin_light_normal_web.png");
  }


  .microsoft-sign-in-btn:hover {
    background-image: url("/assets/app/signup/btn_microsoft_signin_light_focus_web.png");
  }

  .microsoft-sign-in-btn:focus, .microsoft-sign-in-btn:active {
    background-image: url("/assets/app/signup/btn_microsoft_signin_light_pressed_web.png");
    outline: none;
  }

  .microsoft-sign-in-btn {
    background-image: url("/assets/app/signup/btn_microsoft_signin_light_normal_web.png");
  }

  .clever-sign-in-btn:hover {
    background-image: url("/assets/app/signup/btn_clever_signin_light_focus_web.png");
  }

  .clever-sign-in-btn:focus, .clever-sign-in-btn:active {
    background-image: url("/assets/app/signup/btn_clever_signin_light_pressed_web.png");
    outline: none;
  }

  .clever-sign-in-btn {
    background-image: url("/assets/app/signup/btn_clever_signin_light_normal_web.png");
  }
</style>
